import Vue from 'vue'

import withRender from './menu.html'
import './menu.scss'

export default withRender(Vue.extend({
  data() { return { isMenuExpanded: false } },
  methods: {
    // this method can be used by the parent to force the menu to close (clicking outside of the
    // menu for example)
    close() {
      this.setExpanded(false)
    },
    getMenuTrigger() {
      const triggerNodes = this.$slots.menuTrigger
      if (!triggerNodes) {
        // tslint:disable:next-line no-console
        console.error('Could not find "menuTrigger" slot in Menu')
        return null
      }
      return triggerNodes[0]
    },
    menuTriggerSelected(e) {
      if (e.type === 'click' || e.keyCode === 13) {
        this.setExpanded(true)
      }
    },
    setExpanded(expanded, setFocus = true) {
      this.isMenuExpanded = expanded
      const menuTriggerElem = this.getMenuTrigger().elm
      if (menuTriggerElem) {
        this.getMenuTrigger().elm.setAttribute('aria-expanded', expanded)
        if (!this.isMenuExpanded && setFocus) {
          menuTriggerElem.focus()
        }
      }
    }
  },
  mounted() {
    // make sure these are on menu-trigger
    const menuTrigger = this.getMenuTrigger()
    menuTrigger.elm.setAttribute('aria-haspopup', 'menu')
    this.setExpanded(false, false)
    menuTrigger.elm.addEventListener('click', this.menuTriggerSelected)
    if (menuTrigger.elm.tagName !== 'BUTTON') {
      // if a button, it already fires 'click' event when hitting enter key
      // if not a button, need to add this keydown event
      menuTrigger.elm.addEventListener('keydown', this.menuTriggerSelected)
      // also need to make sure it has a role of 'button' then
      menuTrigger.elm.setAttribute('role', 'button')
    }
  },
  beforeDestroy() {
    const menuTrigger = this.getMenuTrigger()
    if (menuTrigger) {
      menuTrigger.elm.removeEventListener('click', this.menuTriggerSelected, false)
      menuTrigger.elm.removeEventListener('keydown', this.menuTriggerSelected, false)
    }
  }
}))
